// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/sea-level-pressure-reduction.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/sea-level-pressure-reduction/sea-level-pressure-reduction.js';

mount([g0]);
